import { postV1, getV1, delV1 } from '@/common/utils/ajax'
import { handleHomeHouses, handleBanner } from '@/common/utils/map_view_data'

const getRecommendConsultant = (opts) => {
    return getV1('recommended_consultant', opts)
}

const getPhonePosition = (param) => {
    return postV1('call_sessions', param)
}

const getPhoneCall = () => {
    return getV1('call_sessions')
}

const getSceneQr = (params) => getV1('scene_qrcode', params)

const like = (type, id, liked) => {
    let likeMethod = delV1
    if (liked) {
        likeMethod = postV1
    }
    return likeMethod('like', {
        likeable_type: type,
        likeable_id: id
    })
}

const generateSubMsg = (v1Method) => {
    return (msgType, targetType, id) => {
        const params = {
            message_type: msgType
        }
        if (targetType) {
            params.targetable_type = targetType
        }
        if (id) {
            params.targetable_id = id
        }
        return v1Method('subscribed_message', params)
    }
}

const subMsg = generateSubMsg(postV1)
const getSubMsg = generateSubMsg(getV1, false)
const delSubMsg = generateSubMsg(delV1)

const addRecommendationClass = (data) => {
    return data.map((item, i) => {
        return {
            ...item,
            class: `Recommendation_${i}`
        }
    })
}

const getRecommendation = (position, options) => getV1('recommendation', {
    limit: 5,
    position,
    ...options
})
    .then(handleHomeHouses)
    .then(addRecommendationClass)
    .catch((err) => {
        console.error(err)
        return []
    })

const getBanner = (position, limit = 4, options = {}) => getV1('recommendation', {
    position,
    limit,
    ...options
})
    .then(handleBanner)

const getSmsCaptchas = (mobile) => postV1('sms_captchas', { mobile })

let phone_auth_error_num = 0

const postWeixinPhone = (iv, encryptedData, errMsg) => {
    if (errMsg === 'getPhoneNumber:ok') {
        return postV1('weixin_phones', {
            iv,
            encryptedData,
            errMsg
        }).then((data) => {
            if (Number(data.code) === 422 && phone_auth_error_num === 0) {
                phone_auth_error_num++
                return postWeixinPhone(iv, encryptedData, errMsg)
            }
            phone_auth_error_num = 0
            return data
        })
    }
    return Promise.reject(errMsg)
}

const addConsultantClient = (id) => postV1('consultant_clients', {
    consultant_id: id
})

const readQuestionHints = (id) => {
    return readHints(id, 'Fc::Question')
}

const readEventHints = (id) => {
    return readHints(id, 'Fc::BuildingEvent')
}

const readHints = (readable_id, readable_type) => {
    const params = {
        readable_type
    }
    if (readable_id) {
        params.readable_id = readable_id
    }
    return postV1('read_hints', params)
}

const checkUrl = (url) => {
    return getV1('black_url', {
        url
    })
}

const getHouseLoanCalc = () => {
    return getV1('house_loan_calculator')
}

const getNcovZones = () => {
    return getV1('ncov2019_zones')
}
const follow = (type, id, followed) => {
    let followMethod = delV1
    let followUrl = 'follows/0'
    if (followed) {
        followMethod = postV1
        followUrl = 'follows'
    }
    return followMethod(followUrl, {
        followable_type: type,
        followable_id: id
    })
}
const delFollow = (followable_type, followable_id) => {
    return delV1('follows/0', {
        followable_type,
        followable_id
    })
}

const checkWords = (content) => {
    return postV1('check_sensitive_words', { content })
}

const postBusinessCooperations = (params) => {
    return postV1('business_cooperations', params)
}

export default {
    getPhonePosition,
    getPhoneCall,
    getSceneQr,
    like,
    delFollow,
    follow,

    subMsg,
    getSubMsg,
    delSubMsg,

    getRecommendation,
    getBanner,
    getSmsCaptchas,

    postWeixinPhone,
    addConsultantClient,

    readHints,
    readQuestionHints,
    readEventHints,

    checkUrl,
    getHouseLoanCalc,
    checkWords,

    getNcovZones,
    getRecommendConsultant,
    postBusinessCooperations
}
